import SuccessDigitize from './styles'
export default SuccessDigitize